import { React } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ForgotPasswordForm from "../components/forgotPasswordForm";
import Footer from "../components/layouts/footer";
import { MainPageHead } from "../components/helpful";


/**
 * A functional component that renders a page for users to recover their forgotten password.
 * It renders a `ForgotPasswordForm` component inside a black filter div.
 * The page also renders a `Footer` component.
 * @function
 * @returns {JSX.Element} The rendered JSX element.
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com>
 */
export default function ForgotPassword() {


  return (
    <div className="login-bg">
      <div className="row black-filter">
        <Row>
          <Col
            className="col-12 col-sm-3 col-lg-3 offset-md-2 offset-sm-2 offset-lg-2 "
            id="main-form-block"
          >
            <div className="">
              <MainPageHead />
              <div>
                <ForgotPasswordForm />
              </div>
            </div>
          </Col>
        </Row>
        <div>
          <Footer islogin={false} />
        </div>
      </div>
    </div>
  );
}
